export default __webpack_public_path__ + "static/media/phone.a5ec9392.svg";